import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh sách đăng ký kiểm tra tiếng anh", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header border-0 pt-6 umt-form" }
const _hoisted_12 = { class: "card-title filter-slim d-flex flex-wrap align-items-center gap-3" }
const _hoisted_13 = { class: "d-flex align-items-center position-relative" }
const _hoisted_14 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_16 = { class: "card-toolbar" }
const _hoisted_17 = {
  class: "d-flex align-items-center gap-2",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle fs-4" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-icon btn-sm btn-secondary umt-btn-32",
  title: "Xuất dữ liệu (Excel)",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" })
], -1)
const _hoisted_21 = {
  class: "menu menu-sub menu-sub-dropdown w-350px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-spreadsheet fs-5 me-3 mt-1 text-gray-500" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "Xuất DS đang xem (nội bộ)", -1)
const _hoisted_24 = { class: "fs-8 fw-normal text-muted" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down fs-5 me-3 mt-1 text-gray-500" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 fw-normal text-muted" }, "Mọi hình thức, chỉ SV đã đóng tiền hoặc đã TNHS", -1)
const _hoisted_27 = { class: "card-body pt-0 umt-table" }
const _hoisted_28 = { class: "fs-8 text-muted fst-italic mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "Chờ xác thực", -1)
const _hoisted_30 = {
  class: "text-center",
  style: {"padding-right":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_9,
        _createTextVNode("Quay lại ")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
              class: "form-control w-250px ps-11",
              style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
              placeholder: "Tìm tên, MSSV, ngành..."
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ]),
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            "popper-class": "filter-slim-dd",
            style: {"width":"190px"},
            placeholder: "Hình thức",
            modelValue: _ctx.filter.method,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.method) = $event)),
            onChange: _ctx.applyFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "— Hình thức xếp lớp —",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "Thi xếp lớp (UMT test)",
                value: "umt_test"
              }),
              _createVNode(_component_el_option, {
                label: "Chứng chỉ Tiếng Anh",
                value: "english_certificate"
              }),
              _createVNode(_component_el_option, {
                label: "Điểm TN THPT",
                value: "english_thpt"
              }),
              _createVNode(_component_el_option, {
                label: "Không kiểm tra xếp lớp",
                value: "none"
              }),
              _createVNode(_component_el_option, {
                label: "Chưa khai hình thức",
                value: "__empty"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            "popper-class": "filter-slim-dd",
            style: {"width":"170px"},
            placeholder: "Trạng thái",
            modelValue: _ctx.filter.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.status) = $event)),
            onChange: _ctx.applyFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "— Trạng thái hồ sơ —",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "Chờ xác thực",
                value: "completed"
              }),
              _createVNode(_component_el_option, {
                label: "Đã hoàn tất",
                value: "confirmed"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            "popper-class": "filter-slim-dd",
            style: {"width":"210px"},
            placeholder: "Thanh toán",
            modelValue: _ctx.filter.payment,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.payment) = $event)),
            onChange: _ctx.applyFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "— Tình trạng hồ sơ —",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "Đã đóng tiền",
                value: "paid"
              }),
              _createVNode(_component_el_option, {
                label: "Đã TNHS",
                value: "received"
              }),
              _createVNode(_component_el_option, {
                label: "Đã đóng tiền hoặc TNHS (mẫu P.ĐT)",
                value: "pdt"
              }),
              _createVNode(_component_el_option, {
                label: "Chưa đóng tiền, chưa TNHS",
                value: "none"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
            title: "Đặt lại toàn bộ bộ lọc"
          }, [
            _hoisted_15,
            _createTextVNode("Đặt lại ")
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", {
              class: "btn btn-sm btn-icon btn-active-light-primary text-primary umt-btn-32",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showExportInfo && _ctx.showExportInfo(...args))),
              title: "2 file xuất khác nhau thế nào?"
            }, _hoisted_19),
            _createElementVNode("div", null, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportFile && _ctx.exportFile(...args))),
                  "data-kt-menu-dismiss": "true",
                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-start text-gray-800 fw-semibold text-hover-primary"
                }, [
                  _hoisted_22,
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, "Đúng " + _toDisplayString(_ctx.tableData.length) + " dòng đang hiển thị, theo bộ lọc hiện tại", 1)
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportingPdt ? null : _ctx.exportForPdt())),
                  "data-kt-menu-dismiss": "true",
                  class: _normalizeClass([_ctx.exportingPdt ? 'opacity-50 pe-none' : 'cursor-pointer text-hover-primary', "menu-item dropdown-item px-3 py-2 d-flex align-items-start text-gray-800 fw-semibold"])
                }, [
                  _hoisted_25,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.exportingPdt ? 'Đang xuất…' : 'Xuất dữ liệu xếp lớp (P.ĐT)'), 1),
                    _hoisted_26
                  ])
                ], 2)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createTextVNode(" Gồm mọi hình thức xếp lớp Tiếng Anh và cả hồ sơ "),
          _hoisted_29,
          _createTextVNode(" — lọc theo Hình thức / Trạng thái để xem riêng từng nhóm. Hiển thị "),
          _createElementVNode("b", null, _toDisplayString(_ctx.tableData.length), 1),
          _createTextVNode("/" + _toDisplayString(_ctx.initCustomers.length) + " hồ sơ. ", 1)
        ]),
        (_ctx.tableData.length != 0)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-fullName": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.fullName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-major": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.major), 1)
              ]),
              "cell-phase": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_30, _toDisplayString(customer.phase), 1)
              ]),
              "cell-studentCode": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.studentCode), 1)
              ]),
              "cell-testdate": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.testdate), 1)
              ]),
              "cell-createdAt": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.createdAt), 1)
              ]),
              "cell-programtype": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.programtype), 1)
              ]),
              "cell-englishMethod": _withCtx(({ row: customer }) => [
                _createTextVNode(_toDisplayString(customer.englishMethod), 1)
              ]),
              "cell-statusLabel": _withCtx(({ row: customer }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(customer.status == 'confirmed' ? 'text-gray-700' : 'text-warning')
                }, _toDisplayString(customer.statusLabel), 3)
              ]),
              "cell-paymentStatus": _withCtx(({ row: customer }) => [
                _createElementVNode("span", {
                  class: _normalizeClass((customer.paid || customer.received) ? 'text-gray-700' : 'text-danger')
                }, _toDisplayString(customer.paymentStatus), 3)
              ]),
              _: 1
            }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"]))
          : (_openBlock(), _createBlock(_component_Datatable, {
              key: 1,
              "table-data": [],
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": false,
              loading: _ctx.loading
            }, null, 8, ["total", "currentPage", "table-header", "rows-per-page", "loading"]))
      ])
    ])
  ]))
}